import angular from 'angular';
import uiRouter from 'angular-ui-router';
import atsiComponent from './atsi.component';

let atsiModule = angular.module('atsi', [
  uiRouter
])

.component('atsi', atsiComponent);

export default atsiModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/atsi/atsi.js